import { AbstractControl, ValidatorFn } from '@angular/forms';

export function setMaxDatePicker(year: number = 1) {
  const currentDate = new Date();
  return {
    maxDate: currentDate.setFullYear(currentDate.getFullYear() - year),
  };
}

export const toDate = (dateStr: string) => {
  const [year, month, day] = dateStr.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const dateRangeValidator: ValidatorFn = (form: AbstractControl): {
  [key: string]: any;
} | null => {
  let invalid = false;
  const from = form && form.get("pepStartDate")!.value;
  const to = form && form.get("pepEndDate")!.value;
  if (from && to) {
    invalid = new Date(from).valueOf() > new Date(to).valueOf();
  }
  return invalid ? { invalidRange: { from, to } } : null;
};